import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  isJson(str: string) {
    try { JSON.parse(str); } catch (e) { return false; }
    return true;
  }

  public getStorageItem(key: string) {
    const item = localStorage.getItem(key) || '';
    return this.isJson(item) ? JSON.parse(item) : item;
  }

  public store(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  public clear(key: string) {
    localStorage.removeItem(key);
  }

  public clearAll() {
    localStorage.clear();
  }

  public gettoken() {
    return this.getStorageItem('token');
  }
}
